type CobbaiChatConfig = {
  chat_id: string;
  auth_token?: string;
};

let cobbaiChatInit = false;

const integrateScript = (cobbaiChatId: string, auth_token?: string) => {
  let config: CobbaiChatConfig = {
    chat_id: cobbaiChatId,
  };
  if (auth_token) {
    config.auth_token = auth_token;
  }
  const script = document.createElement("script");
  script.id = "cobbai-chat-init-script";
  const chatParameters = new URLSearchParams(config).toString();
  script.src = `https://interstis.cobbai.com/connectors/chats/conversations/init?${chatParameters}`;
  script.async = true;
  script.onload = () => {
    cobbaiChatInit = true;
  };
  document.head.appendChild(script);
};

export const integrateWithToken = async (
  baseUrl: string,
  cobbaiChatId: string,
) => {
  if (cobbaiChatInit) {
    console.debug("CobbAI Chat is already initialized.");
    return;
  }
  let auth_token = null;
  try {
    const response = await fetch(`${baseUrl}/api-token/cobbai`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });
    if (response.ok) {
      const data = await response.json();
      auth_token = data.token;
    }
  } catch (error) {
    console.error("Error fetching CobbAI auth token:", error);
  }
  if (!auth_token) {
    console.warn(
      "Error when fetching CobbAI auth token. CobbAI Chat will not be initialized.",
    );
    return null;
  }
  integrateScript(cobbaiChatId, auth_token);
};
